module.exports = __webpack_public_path__ + "static/map_usa_MW_mobile-f62453aa9f3645bfb0da182839b01957.png";